import React, { useEffect, useState } from "react";
import Nav from "../components/smart/Nav";
import TaskEditor from "../components/smart/TaskEditor";
import Suggestions from "../components/smart/Suggestions";
import TaskNotes from "../components/smart/TaskNotes";
import { useSelector } from "react-redux";
import TaskRowComment from "../components/smart/TaskRowComment";

const TranslationRoute = ({ match }) => {
  const taskID = match.params.taskID;
  const task = useSelector((state) => state.task?.tasks[taskID]);
  const [activeRowID, setActiveRowID] = useState(null);

  return (
    <React.Fragment>
      <Nav>
        <div className="nav__item">
          {task?.status} - "{task?.name}""
        </div>
      </Nav>
      <div className="columns-container">
        <div className="column column--primary">
          <TaskEditor taskID={taskID} onRowChange={setActiveRowID} />
        </div>

        <div className="column column--suggestions">
          <div className="column--suggestions__fixed-container">
            <Suggestions taskID={taskID} rowID={activeRowID} />

            <TaskRowComment taskID={taskID} />

            <TaskNotes taskID={taskID} />

            <div class="info-block">
              <div>
                <i
                  class="fas fa-info-circle info-block__info-icon"
                  aria-hidden="true"
                ></i>
              </div>

              <table>
                <tbody>
                  <tr>
                    <td>
                      <div class="keyboard-key">CTRL</div>
                      <div class="keyboard-key">Z</div>
                    </td>
                    <td class="info-block__action">Undo</td>
                  </tr>
                  <tr>
                    <td>
                      <div class="keyboard-key">CTRL</div>
                      <div class="keyboard-key">Enter</div>
                    </td>
                    <td class="info-block__action">Confirm segment</td>
                  </tr>

                  <tr>
                    <td>
                      <div class="keyboard-key">CTRL</div>
                      <div class="keyboard-key">
                        <i
                          class="fas fa-long-arrow-alt-up"
                          aria-hidden="true"
                        ></i>
                      </div>
                    </td>
                    <td class="info-block__action">Row up</td>
                  </tr>
                  <tr>
                    <td>
                      <div class="keyboard-key">CTRL</div>
                      <div class="keyboard-key">
                        <i
                          class="fas fa-long-arrow-alt-down"
                          aria-hidden="true"
                        ></i>
                      </div>
                    </td>
                    <td class="info-block__action">Row down</td>
                  </tr>

                  <tr>
                    <td>
                      <div class="keyboard-key">CTRL</div>
                      <div class="keyboard-key">/</div>
                    </td>
                    <td class="info-block__action">Grab source</td>
                  </tr>

                  <tr>
                    <td>
                      <div class="keyboard-key">CTRL</div>
                      <div class="keyboard-key">ALT</div>
                      <div class="keyboard-key">1-9</div>
                    </td>
                    <td class="info-block__action">Grab TM</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default TranslationRoute;
